// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2JD-0","icon":"style_icon__1thpD"};